import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiService } from '@insight/services';

export interface User {
	userId: number;
	employeeCode: string;
	fullName: string;
	occupationName: string;
	userImagePath: string;
	defaultRoute: string;
	token: string;
	refreshToken: string;
}

@Injectable({
	providedIn: 'root'
})
export class AuthenticateService {

	constructor(
		private apiService: IApiService
	) { }

	authenticate(credentials: any): Observable<number> {
		return this.apiService.post(`/auth/authenticate`, credentials);
	}
}
